export const GET_ORGS_NAME_DATA = 'get_orgname_data';
export const GET_ORGS_NAME_DATA_SUCCESSFUL = 'get_orgname_data_successful';
export const GET_ORGS_NAME_DATA_FAILED = 'get_orgname_data_failed';